// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__Modal__ModalHeader__root","libraryTabs":"CentricUI__Modal__ModalHeader__libraryTabs","goBack":"CentricUI__Modal__ModalHeader__goBack","closeLink":"CentricUI__Modal__ModalHeader__closeLink","buttons":"CentricUI__Modal__ModalHeader__buttons","draftButton":"CentricUI__Modal__ModalHeader__draftButton","seasonSelectors":"CentricUI__Modal__ModalHeader__seasonSelectors","searchBar":"CentricUI__Modal__ModalHeader__searchBar","closeButton":"CentricUI__Modal__ModalHeader__closeButton","itemNoun":"CentricUI__Modal__ModalHeader__itemNoun"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalHeader.css
// module id = 1085
// module chunks = 10